<template>
  <div class="card">
    <el-row :gutter="20">
      <el-col :span="screenWidth <= 540?12:6">
        <div>
          <img :src="item.imgUrl" alt="" class="card-img">
        </div>
      </el-col>
      <el-col :span="screenWidth <= 540?12:18">
        <div class="card-content">
          <div class="card-content-title" @click="toDetails">
            <h3 style="font-weight: 600;">{{ item.createDate }}</h3>
            <h4 class="news-title">{{ item.title }}</h4>
          </div>
          <div class="news-title">{{ item.digest }}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'listCard',
  computed: {
    ...mapState(['screenWidth'])
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
	fundId:{}
  },
  data() {
    return {
      
    };
  },
  methods: {
    toDetails() {
      this.$router.push({
        path: '/specialFundNewsDetails',
        query: {
          id: this.item.id,
		  fundId:this.fundId
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.card {
  width: 100%;
  border-radius: 0.1rem;
  overflow: hidden;
  background: #FAFAFB;
  margin-top: 2rem;
  height: 9.7rem;
}
.card-content{
  padding: 0rem;
  position: relative;
  cursor: pointer;
  .card-content-title:hover{
    color: #375494;
  }
}
.card-img{
  width: 100%;
  height: 9.7rem;
  object-fit: cover;
}
</style>